import { render } from "./DocumentUploader.vue?vue&type=template&id=67b7c0aa&scoped=true"
import script from "./DocumentUploader.vue?vue&type=script&lang=js"
export * from "./DocumentUploader.vue?vue&type=script&lang=js"

import "./DocumentUploader.vue?vue&type=style&index=0&id=67b7c0aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b7c0aa"]])

export default __exports__